export interface Auth0OptionSettings {
  audienceSetting: unknown
  gqlEndpoint: unknown
  refreshTokensSetting: unknown
}

export interface Auth0OptionChoice {
  audience: string | undefined
  refreshTokens: boolean
}

const setAudience = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined
  const trimmed = value.trim()
  return trimmed === '' ? undefined : trimmed
}

const todaysAudience = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined

export const chooseAuth0Options = ({
  audienceSetting,
  gqlEndpoint,
  refreshTokensSetting
}: Auth0OptionSettings): Auth0OptionChoice => ({
  audience: setAudience(audienceSetting) ?? todaysAudience(gqlEndpoint),
  refreshTokens: refreshTokensSetting === 'true'
})
